import { loadJs, loadCss } from 'bits/load'

declare var katex: any

const scriptUrl = 'https://cdnjs.cloudflare.com/ajax/libs/KaTeX/0.10.2/katex.min.js'
const styleUrl = 'https://cdnjs.cloudflare.com/ajax/libs/KaTeX/0.10.2/katex.min.css'

export async function mathifyElement (elem: HTMLElement): Promise<void> {
  await Promise.all([loadJs(scriptUrl), loadCss(styleUrl)])
  katex.render(elem.innerText, elem, { displayMode: false })
}